module.exports = __webpack_public_path__ + "img/sdg_en_(13).b02466ab.png";